import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { useT } from "../translations/translations";

const NotFound = () => {
  const { currentLang } = useContext(LanguageContext);
  const t = useT(currentLang);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f7f5f2]">
      <div className="max-w-[420px] w-full text-center bg-white px-14 py-16 rounded-2xl shadow-[0_20px_40px_rgba(0,0,0,0.08)]">
        <h1 className="text-[96px] font-extrabold text-[#8b6b4a] leading-none">
          404
        </h1>

        <h2 className="mt-3 text-2xl font-semibold text-slate-800">
          {t.common.pageNotFound}
        </h2>

        <p className="mt-3 text-sm text-slate-600 leading-relaxed">
          {t.common.pageNotFoundDesc}
        </p>

        <Link
          to="/"
          className="inline-block mt-8 px-7 py-3 rounded-full bg-[#8b6b4a] text-white text-sm font-medium transition hover:bg-[#74573b] hover:-translate-y-[1px]"
        >
          {t.common.goHome}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
